import { getAddressFieldsConfig } from '../../LoanApplication.sharedConfigs';
import { appraisalConfigFields } from '../../tabs/propertyAndLoan/EditModal/Content/MainContent/Appraisal/Appraisal.config';
import { creditFields } from '../../tabs/propertyAndLoan/EditModal/Content/MainContent/Credits/Credits.config';
import { loanInfoConfigFields } from '../../tabs/propertyAndLoan/EditModal/Content/MainContent/LoanInfo/LoanInfo.config';
import { projectConfigFields } from '../../tabs/propertyAndLoan/EditModal/Content/MainContent/Project/Project.config';
import { propertyConfigFields } from '../../tabs/propertyAndLoan/EditModal/Content/MainContent/Property/Property.config';
import {
  existingPropertyExpensesFields,
  proposedPropertyExpensesFields,
} from '../../tabs/propertyAndLoan/EditModal/Content/MainContent/PropertyExpenses/PropertyExpenses.config';
import { transactionDetailsConfigFields } from '../../tabs/propertyAndLoan/EditModal/Content/MainContent/TransactionDetails/TransactionDetails.config';
import {
  ENTITY_TYPE_HREF_MAP,
  LOAN_AND_LOCK_SECTION_HREF_MAP,
  LOAN_AND_LOCK_SECTION_NAME_MAP,
  PROPERTY_SECTION_HREF_MAP,
  PROPERTY_SECTION_NAME_MAP,
} from '../../tabs/propertyAndLoan/EditModal/EditModal.constants';

const addressConfigFields = getAddressFieldsConfig({
  prefix: '',
  isWithCountry: false,
});

export const STATIC_FIELD_SECTION_CONFIGS = [
  {
    configFields: { ...proposedPropertyExpensesFields, ...existingPropertyExpensesFields },
    sectionName: PROPERTY_SECTION_NAME_MAP[PROPERTY_SECTION_HREF_MAP.PROPERTY_EXPENSES],
    entityType: ENTITY_TYPE_HREF_MAP.PROPERTY_INFO,
    sectionHref: PROPERTY_SECTION_HREF_MAP.PROPERTY_EXPENSES,
    dataSourceKey: 'subjectProperty',
  },
  {
    configFields: appraisalConfigFields,
    sectionName: PROPERTY_SECTION_NAME_MAP[PROPERTY_SECTION_HREF_MAP.APPRAISAL],
    entityType: ENTITY_TYPE_HREF_MAP.PROPERTY_INFO,
    sectionHref: PROPERTY_SECTION_HREF_MAP.APPRAISAL,
    dataSourceKey: 'subjectProperty',
  },
  {
    configFields: projectConfigFields,
    sectionName: PROPERTY_SECTION_NAME_MAP[PROPERTY_SECTION_HREF_MAP.PROJECT],
    entityType: ENTITY_TYPE_HREF_MAP.PROPERTY_INFO,
    sectionHref: PROPERTY_SECTION_HREF_MAP.PROJECT,
    dataSourceKey: 'subjectProperty',
  },
  {
    configFields: transactionDetailsConfigFields,
    sectionName: PROPERTY_SECTION_NAME_MAP[PROPERTY_SECTION_HREF_MAP.TRANSACTION_DETAILS],
    entityType: ENTITY_TYPE_HREF_MAP.PROPERTY_INFO,
    sectionHref: PROPERTY_SECTION_HREF_MAP.TRANSACTION_DETAILS,
    dataSourceKey: 'subjectProperty',
  },
  {
    configFields: creditFields,
    sectionName: LOAN_AND_LOCK_SECTION_NAME_MAP[LOAN_AND_LOCK_SECTION_HREF_MAP.CREDITS],
    entityType: ENTITY_TYPE_HREF_MAP.LOAN_AND_LOCK,
    sectionHref: LOAN_AND_LOCK_SECTION_HREF_MAP.CREDITS,
    dataSourceKey: 'loanApplicationData',
  },
];

export const VISIBILITY_FILTERED_SECTION_CONFIGS = [
  {
    configFields: { ...propertyConfigFields, ...addressConfigFields },
    sectionName: PROPERTY_SECTION_NAME_MAP[PROPERTY_SECTION_HREF_MAP.PROPERTY],
    entityType: ENTITY_TYPE_HREF_MAP.PROPERTY_INFO,
    sectionHref: PROPERTY_SECTION_HREF_MAP.PROPERTY,
    dataSourceKey: 'propertyDataSource',
  },
  {
    configFields: loanInfoConfigFields,
    sectionName: LOAN_AND_LOCK_SECTION_NAME_MAP[LOAN_AND_LOCK_SECTION_HREF_MAP.LOAN_INFO],
    entityType: ENTITY_TYPE_HREF_MAP.LOAN_AND_LOCK,
    sectionHref: LOAN_AND_LOCK_SECTION_HREF_MAP.LOAN_INFO,
    dataSourceKey: 'loanApplicationData',
  },
];

export const LOCK_INFO_SECTION_CONFIG = {
  sectionName: LOAN_AND_LOCK_SECTION_NAME_MAP[LOAN_AND_LOCK_SECTION_HREF_MAP.LOCK_INFO],
  entityType: ENTITY_TYPE_HREF_MAP.LOAN_AND_LOCK,
  sectionHref: LOAN_AND_LOCK_SECTION_HREF_MAP.LOCK_INFO,
  dataSourceKey: 'loanApplicationData',
};
